var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "layout" }, [
    _c("div", { staticClass: "layout__header" }, [
      _c("div", { staticClass: "lyaout__title" }),
      _vm._v(" "),
      _c("div", { staticClass: "layout__controls" }, [
        _c("div", { staticClass: "form-inline" }, [
          _c(
            "button",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.id !== "",
                  expression: "id !== ''"
                }
              ],
              staticClass: "btn-info btn--bigger",
              attrs: { type: "button" },
              on: { click: _vm.imprimir }
            },
            [
              _c("i", { staticClass: "fa fa-print" }),
              _c("span", [_vm._v("Imprimir")])
            ]
          )
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-xs-12 col-md-4" }, [
        _c("div", { staticClass: "form-field select2" }, [
          _c(
            "div",
            { staticClass: "select2-field" },
            [
              _c("v-select", {
                attrs: {
                  label: "descripcion",
                  id: "vendedor_id",
                  options: _vm.vendedores
                },
                on: { search: _vm.searchVendedores, input: _vm.inputVendedor },
                model: {
                  value: _vm.selectedVendedor,
                  callback: function($$v) {
                    _vm.selectedVendedor = $$v
                  },
                  expression: "selectedVendedor"
                }
              }),
              _vm._v(" "),
              _c("label", { attrs: { for: "vendedor_id" } }, [
                _vm._v(
                  "\n                        Vendedor a referir\n                    "
                )
              ])
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-xs-12" },
        [
          _c("k-table-select", {
            ref: "kTableSelectVen",
            attrs: {
              columnas: [
                {
                  nombre: "numero_documento",
                  descripcion: "Número de documento",
                  link: true
                },
                {
                  nombre: "cliente.descripcion_cliente",
                  descripcion: "Cliente"
                },
                {
                  nombre: "fecha",
                  descripcion: "Fecha",
                  sortable: true
                },
                {
                  nombre: "valor_total",
                  descripcion: "Valor total",
                  sortable: true
                },
                {
                  nombre: "valor_comision",
                  descripcion: "Comisión",
                  money: true,
                  sortable: true
                }
              ],
              params: {
                supervisor_id: _vm.supervisor_id,
                tipoVenta: "LQ",
                liquidacion_id: _vm.liquidacionId
              },
              cargaAutomatica: false,
              urlConsulta: _vm.url + "/ventas-nomina-supervisor",
              title: ""
            },
            on: { cerrar: _vm.cerrar, seleccionar: _vm.referir },
            model: {
              value: _vm.tarjetas,
              callback: function($$v) {
                _vm.tarjetas = $$v
              },
              expression: "tarjetas"
            }
          })
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7dc89fa7", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7dc89fa7","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/nomina/ReferirTarjetas.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-7dc89fa7","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/nomina/ReferirTarjetas.vue
// module chunks = 0